// Values are the exact display strings the BE/USD payload expects (case-sensitive wire contract).
export enum ShipSelection {
  DELIVERY_AFTER = 'Delivery After',
  DELIVERY_BY = 'Delivery By',
  DELIVERY_ON = 'Delivery On',
  DELIVERY_WITHIN = 'Delivery Within',
  NO_DELIVERY_DATE = 'No Delivery Date',
}
